import React from "react";
import { t } from "i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

// import PageHeader from "components/PageHeader";
// import FixedFooter from "components/FixedFooter";
import WithMap from "components/Hoc/WithMap";
import { ErrorModal, CustomModal } from "components";
import { useCustomHistory } from "hooks";
import { useMapContext } from "contexts/googleMap";
import { CustomButton } from "components/Button";
import { TranslationText } from "components/TextTranslationContainer";
import { PageHeaderV2 } from "components/PageHeader";
import useDelivertPickupFn from "features/hooks/useDelivertPickupFn";

// todo: requires cleanup
function AddGoogleMapLocation({
  checkoutPageUrl,
  handleConfirmLocation,
  error,
  open,
  setOpen,
  mapref,
  setMapRef,
  googlemapState,
}) {
  const { goToLogin, goToSettings } = useDelivertPickupFn();
  const params = useParams();
  const router = useCustomHistory();
  const { DomainType } = useSelector((state) => state.AppReducer);
  const { setZoom } = useMapContext();

  const goToCheckoutPage = () => {
    router(
      checkoutPageUrl,
      `/${params?.domainName}${checkoutPageUrl}`,
      DomainType
    );
  };
  const handleClik = () => {
    setOpen(false);
    if (error?.type === "zoom") {
      setZoom(16);
    }
  };

  return (
    <React.Fragment>
      <div className="flex flex-col min-h-full store-page-popup">
        <PageHeaderV2
          pageTitle={"Set Delivery Location"}
          onGoBack={goToCheckoutPage}
          authClick={goToLogin}
          userClick={goToSettings}
          containerStyleProps={{
            style: {
              position: "sticky",
              zIndex: 10,
            },
          }}
        />
        <div
          className="p-4 flex flex-col gap-2 justify-between"
          style={{ height: "calc(100% - 75px)" }}
        >
          <div>
            <TranslationText
              text="Where should we deliver"
              as="h1"
              className="text-24x font-bold text-shadow-forge-900"
            />
            <TranslationText text="We need your location to check if this restaurant delivers to you." />
          </div>
          <WithMap
            class="flex-1"
            screenName={null}
            width="100%"
            height={"calc(100% - 75px)"}
            showInput={true}
            zoomChanging={true}
            setMapRef={setMapRef}
            mapref={mapref}
            googlemapState={{
              userLocation: {
                lat: googlemapState?.userLocation?.coordinates?.lat,
                lng: googlemapState?.userLocation?.coordinates?.lng,
              },
              zoom: googlemapState?.zoom,
              mapAddress: googlemapState?.mapAddress,
            }}
            zoomerror={error?.msg || error}
            isZoomModalOpen={error?.type === "zoom" ? open : false}
            setZoomErrorModal={setOpen}
          />
          <CustomButton onClick={handleConfirmLocation}>
            <TranslationText text="Confirm Location" />
          </CustomButton>
        </div>
        <CustomModal
          open={error?.type !== "zoom" ? open : false}
          setOpen={setOpen}
          bodyclasses="flex"
          overlayClasses="  fixed h-screen w-screen top-0 bg-opacity-50 overflow-hidden transition ease-linear duration-700 z-40"
        >
          <ErrorModal
            message={error?.msg || error}
            btnTitle={error?.type === "zoom" ? t("Increase zoom") : null}
            handleClik={handleClik}
          />
        </CustomModal>
      </div>
    </React.Fragment>
  );
}

export default AddGoogleMapLocation;
